module.exports = __webpack_public_path__ + "img/second-bg-container.e110aebb.webp";